var exports = {
  "kR": "x28a7bf27--60c303--cards",
  "Nr": "x28a7bf27--60c303--card",
  "_8": "x28a7bf27--60c303--img",
  "DD": "x28a7bf27--60c303--title",
  "Qq": "x28a7bf27--60c303--text",
};

module.exports = exports;
